module.exports = __webpack_public_path__ + "static/img/ROME-BURGOYNE.4827f88.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ROME-BURGOYNE.jpg
// module id = rkvi
// module chunks = 0